import { Heart } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { BabyName } from '../types';

interface NameCardProps {
  name: BabyName;
  style?: React.CSSProperties;
  className?: string;
}

const genderConfig = {
  male: {
    symbol: '♂',
    iconClass: 'gender-icon male',
    textColor: 'text-pp-dark',
  },
  female: {
    symbol: '♀',
    iconClass: 'gender-icon female',
    textColor: 'text-pp-dark',
  },
  neutral: {
    symbol: '⚥',
    iconClass: 'gender-icon neutral',
    textColor: 'text-pp-dark',
  },
};

const originLabels: Record<string, string> = {
  german: 'Deutsch',
  english: 'Englisch',
  french: 'Französisch',
  italian: 'Italienisch',
  spanish: 'Spanisch',
  turkish: 'Türkisch',
  arabic: 'Arabisch',
  hebrew: 'Hebräisch',
  greek: 'Griechisch',
  latin: 'Lateinisch',
  nordic: 'Nordisch',
  slavic: 'Slawisch',
  celtic: 'Keltisch',
  indian: 'Indisch',
  japanese: 'Japanisch',
  chinese: 'Chinesisch',
  african: 'Afrikanisch',
  american: 'Amerikanisch',
};

export function NameCard({ name, style, className }: NameCardProps) {
  const gender = genderConfig[name.gender];
  const originLabel = originLabels[name.origin.toLowerCase()] || name.origin;

  return (
    <div
      className={cn(
        'name-card touch-none select-none',
        className
      )}
      style={style}
    >
      {/* Gender Icon */}
      <div className={gender.iconClass}>
        <span className="text-2xl text-pp-dark">{gender.symbol}</span>
      </div>

      {/* Name */}
      <h2 className="text-center text-4xl font-bold text-pp-dark mb-3">{name.name}</h2>

      {/* Origin Badge */}
      <div className="text-center mb-3">
        <span className="origin-tag">{originLabel}</span>
      </div>

      {/* Meaning */}
      {name.meaning && (
        <p className="text-center text-pp-dark/70 mb-2">
          „{name.meaning}"
        </p>
      )}

      {/* Popularity */}
      {name.popularity_rank && name.popularity_rank <= 100 && (
        <div className="flex items-center justify-center gap-2">
          <Heart className="w-4 h-4 text-pp-teal fill-pp-teal" />
          <span className="text-pp-teal font-medium text-sm">
            Top {name.popularity_rank} in Deutschland
          </span>
        </div>
      )}
    </div>
  );
}
